export default __webpack_public_path__ + "image/header-status-2@3x-1704e367.jpg";